import { Component, Input, OnInit } from '@angular/core';

import { StateService } from '@uirouter/angular';
import { UiService } from '../../../services/core.ui.service';
import { GfTranslateService } from '../../../services/core.translate.service';
import { ProjectSprintData } from '../services/project.sprint.data.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ProjectService } from '../../../services/project.service';

import * as _ from 'lodash';
import { GfTitleService } from '../../../services/core.title.service';
import { ProjectSprintEditComponent } from './projectSprintEdit/project.sprint.edit.component';
import { ProjectSprintCutoverComponent } from './projectSprintCutover/project.sprint.cutover.component';
import { ProjectSprintDeleteComponent } from './projectSprintDelete/project.sprint.delete.component';
import { ProjectSprintAddModalComponent } from './projectSprintAdd/project.sprint.add.component';

@Component({
    selector: 'project-sprints',
    template: require('./project.sprints.html'),
})
export class ProjectSprintsComponent  implements OnInit {
    @Input() project: any;
    @Input() projectMenu: any;

    protected breadcrumbs: any = null;
    protected isSprintAdmin: boolean = false;

    // Pass-through functions from ProjectSprintData
    private getLabelText: (status: any) => string;
    protected getActionLabel: (status: any) => string;
    protected getActionClass: (status: any) => string;
    protected getGlyphicon: (status: any) => string;
    protected getCompletePercent: (closed: number, total: number) => number;
    protected getTitle: (sprint: any) => string;

    // Modal data
    private newsprint: any = null;
    private currentSprintUpdate: any = {};
    private moveTickets: { option: boolean; nextSprint: any; sprints: any[] } = {
        option: true,
        nextSprint: null,
        sprints: [],
    };

    // Filters and sorting
    protected filters: any = null;
    protected sortFields: any = null;
    private sort: any = null;

    // Sprints
    protected sprints: any[] = [];
    protected refresh: () => void;

    constructor(
        private projectService: ProjectService,
        private stateService: StateService,
        
        private uiService: UiService,
        private window: Window, // $window
        private gfTranslateService: GfTranslateService,
        private projectSprintData: ProjectSprintData,
        private modalService: NgbModal,
        private titleService: GfTitleService,
    ) { }

    ngOnInit(): void {
        this.titleService.setTitle(_.get(this.project, 'name', ''), this.gfTranslateService.translate('Sprints'));

        this.breadcrumbs = this.projectSprintData.getBreadcrumbs(this.project);

        this.isSprintAdmin = _.get(this.project, 'rel.permissions.admin', false) ||
            _.get(this.project, 'rel.permissions.sprintAdmin', false);

        // Pass-through functions from ProjectSprintData
        this.getLabelText = (status) => this.projectSprintData.getSprintLabelText(status);
        this.getActionLabel = (status) => this.projectSprintData.getSprintActionLabel(status);
        this.getActionClass = (status) => this.projectSprintData.getSprintActionClass(status);
        this.getGlyphicon = (status) => this.projectSprintData.getSprintActionGlyph(status);
        this.getCompletePercent = (closed, total) => this.projectSprintData.getCompletePercent(closed, total);
        this.getTitle = (sprint) => this.projectSprintData.getSprintTitle(sprint);

        // Initial values for modal data
        this.newsprint = this.projectSprintData.getDefaultNewSprint(this.project);
        this.currentSprintUpdate = {};
        this.moveTickets = {
            option: true,
            nextSprint: null,
            sprints: []
        };

        // Set up the list of filters, setting any filter values
        // that exist in the $stateParams (querystring)
        this.filters = this.projectSprintData.setFilterValues(
            this.projectSprintData.createSprintFilters(),
            this.stateService.params
        );
        this.sortFields = this.projectSprintData.getSprintSortFields();
        this.sort = this.projectSprintData.getSprintSort(this.stateService.params);

        this.getSprints();
        this.refresh = this.getSprints;
    };

    async showSprintAddModal() {

        const templateSprint = await this.setupNewSprint();
        const modalRef = this.modalService.open(ProjectSprintAddModalComponent);
        modalRef.componentInstance.sprint = this.projectSprintData.getNewSprint(templateSprint, this.project);
        modalRef.componentInstance.project = this.project;
        modalRef.componentInstance.close.subscribe((success) => {
            modalRef.close();
            if (success) this.getSprints();
        });
    };

    showSprintEditModal(sprint) {
        const modalRef = this.modalService.open(ProjectSprintEditComponent);
        modalRef.componentInstance.sprint = sprint;
        modalRef.componentInstance.project = this.project;
        modalRef.componentInstance.close.subscribe((success) => {
            modalRef.close();
            if (success) this.getSprints();
        });
    };

    showSprintDeleteModal(sprint) {
        const modalRef = this.modalService.open(ProjectSprintDeleteComponent);
        modalRef.componentInstance.sprint = sprint;
        modalRef.componentInstance.project = this.project;
        modalRef.componentInstance.close.subscribe((success) => {
            modalRef.close();
            if (success) this.getSprints();
        });
    };

    showSprintCutoverModal(sprint) {
        const modalRef = this.modalService.open(ProjectSprintCutoverComponent);
        modalRef.componentInstance.sprint = sprint;
        modalRef.componentInstance.project = this.project;
        modalRef.componentInstance.close.subscribe((success) => {
            modalRef.close();
            if (success) this.getSprints();
        });
    };

    resetFilters() {
        // Create a new set of filters with no values set
        this.filters = this.projectSprintData.createSprintFilters();

        // Do we want to refresh, or just reset values and wait for apply button?
        this.projectSprintData.applyFilters(this.filters, this.sort);
    };

    applyFilters() {
        this.projectSprintData.applyFilters(this.filters, this.sort);
    };

    setSort(params) {
        this.sort = {
            field: params.key,
            dir: params.sortDir
        };
        this.projectSprintData.applyFilters(this.filters, this.sort);
    };

    onPage(params) {
        this.stateService.go('.', params);
    };

    changeStatus(sprint) {
        var status;

        switch (sprint.sprintStatus) {
            case 0:
                status = 1;
                break;
            case 1:
                status = 2;
                break;
            case 2:
                status = 0;
                break;
        }

        this.projectService.updateSprint(
            {
                id: sprint.id,
                project: this.project.id,
                sprintStatus: status
            }
        ).then(
            () => {
                this.uiService.message.showSuccess(this.gfTranslateService.translate('The sprint has been succesfuly updated.'), 'Sprint updated');
                this.getSprints();
            },
            () => {
                var msg = this.gfTranslateService.translate('There was a problem updating the sprint');
                this.uiService.message.showWarning(msg, 'Data Error');
            }
        );
    };

    setupNewSprint() {
        var params = {
            page_size: 1,
            page_num: 1,
            sort_field: 'id',
            sort_dir: 'desc'
        };

        return this.projectService.sprints(this.project.unixName, params)
            .then(
                (response) => {
                    return this.projectSprintData.getNewSprint(
                        _.get(response, 'items[0]', this.projectSprintData.getDefaultNewSprint(this.project)),
                        this.project
                    );
                }
            );
    };

    getSprints() {
        this.sprints = null;

        const { unixName, ...rest } = this.stateService.params;

        const params = _.reduce(
            rest,
            (carry, item, key) => {
                if (item) {
                    carry[key] = item;
                }
                return carry;
            },
            {}
        );

        this.projectService.sprints(unixName, params)
            .then(
                (response) => {
                    this.sprints = _.get(response, 'items', []);
                },
                () => {
                    this.sprints = [];
                    var msg = this.gfTranslateService.translate('There was a problem loading project sprints');
                    this.uiService.message.showWarning(msg, 'Data Error');
                }
            );
    }
}